import type { ActivitiesResponse } from '@popety-io/types'
import { apiClient } from '@/services/apiClient'

export const activitiesService = {
  /**
   * Fetch activities for a specific land
   */
  getByLandId: async (landId: string): Promise<ActivitiesResponse> => {
    // Only import apiClient when needed
    const response = await apiClient.get(`/activities/land/${landId}`)
    return response.data
  },
}
